// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1tVqn","label":"Radio_label__sGSHV","checkMark":"Radio_checkMark__MHkcU","disabled":"Radio_disabled__H5Rc6"};